// eslint-disable-next-line no-console
export const log = console.log.bind(console);

// eslint-disable-next-line no-console
export const error = console.error.bind(console);

/** @type {Map<string, string>} */
export const countryMap = new Map([
    ["US", "USA"],
    ["default", "ISO"],
]);

/** @type {Map<string, string[]>} */
export const protocolKeyMap = new Map([
    ["all_on_4", ["Nobel Biocare", "ImplantDirect", ""]],
    ["all_on_6", ["Nobel Biocare", "ImplantDirect", ""]],
    // TODO: add dentures bar... 2020.09.18
    ["dentures_with_bar", ["Nobel Biocare", "ImplantDirect", ""]],
    ["fast_and_fixed_4", ["BlueSky"]],
    ["fast_and_fixed_6", ["BlueSky"]],
    // TODO: add full dentures... 2020.09.18
    ["full_dentures", ["{extra_treatments.lab_made}"]],
    ["full_bridge", ["extra_treatments.porcelain_fused_to_metal", "extra_treatments.zirconium"]],
    ["full_jaw_6_12", [
        "Nobel Biocare - {extra_treatments.porcelain_fused_to_metal}",
        "ImplantDirect - {extra_treatments.porcelain_fused_to_metal}",
        "Nobel Biocare - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.zirconium}",
        "ImplantDirect - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.porcelain_fused_to_metal}",
    ]],
    ["full_jaw_6_14", [
        "Nobel Biocare - {extra_treatments.porcelain_fused_to_metal}",
        "ImplantDirect - {extra_treatments.porcelain_fused_to_metal}",
        "Nobel Biocare - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.zirconium}",
        "ImplantDirect - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.porcelain_fused_to_metal}",
    ]],
    ["full_jaw_8_12", [
        "Nobel Biocare - {extra_treatments.porcelain_fused_to_metal}",
        "ImplantDirect - {extra_treatments.porcelain_fused_to_metal}",
        "Nobel Biocare - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.zirconium}",
        "ImplantDirect - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.porcelain_fused_to_metal}",
    ]],
    ["full_jaw_8_14", [
        "Nobel Biocare - {extra_treatments.porcelain_fused_to_metal}",
        "ImplantDirect - {extra_treatments.porcelain_fused_to_metal}",
        "Nobel Biocare - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.zirconium}",
        "ImplantDirect - {extra_treatments.zirconium}",
        "Straumann - {extra_treatments.porcelain_fused_to_metal}",
    ]],
    ["mini_4", ["DenTi"]],
    ["mini_6", ["DenTi"]],
    ["one_phase_8", ["BCS", "KOS"]],
    ["preci_vertix", ["extra_treatments.porcelain_fused_to_metal", "extra_treatments.zirconium"]],
]);

/** @type {Map<number, string>} */
export const languageKeyMap = new Map([
    [7, "plan_calculator.state_6"],
    [9, "plan_calculator.state_9"],
    [10, "plan_calculator.group_1"],
    [11, "plan_calculator.group_1"],
    [312, "plan_calculator.group_1"],
    [12, ""], // translate - Gyógyulási csavar
    [924, ""], // translate - Ínyformázó
    [13, ""], // translate - Felépítmény
    [15, "plan_calculator.state_15"],
    [304, ""], // translate - Rögzítőcsavar
    [313, ""], // translate - Rögzítőcsavar
    [315, "plan_calculator.state_315"],
    [302, "plan_simple.template_preci_vertix"],
    [300, "plan_calculator.state_300"],
    [306, ""], // translate - Részleges fogsor
    [303, ""], // translate - Műínyes híd
    [308, ""], // translate - Fogsor (teljes akrilát)
    [316, ""], // translate - Fogsor (teljes akrilát)
    [14, ""], // translate - Lenyomatvétel
    [19, ""], // translate - Csiszolás
    [25, ""], // translate - Héj előkészítése
    [26, "plan_calculator.group_7"],
    [27, "extra_treatments.filling"],
    [33, "extra_treatments.extractions"],
    [199, "protocol_steps.animation_title_199_multiple"],
    [200, ""], // translate - Fogmű levétele
    [207, "plan_calculator.other"],
    [1001, "Nobel Biocare"],
    [1002, "ImplantDirect"],
    [1003, "Straumann"],
    [1004, "BCS/KOS"],
    [2001, "extra_treatments.porcelain_fused_to_metal"], // translate - Fémkerámia
    [2002, "extra_treatments.zirconium"], // translate - Cirkónium
    [3001, "extra_treatments.surgery_made"],
    [3002, "extra_treatments.lab_made"], // translate - Technikai
    [5000, "extra_treatments.extractions"],
    [5001, "extra_treatments.filling"],
    [5002, "extra_treatments.filling_medium"],
    [5003, "extra_treatments.filling_large"],
    [5011, "extra_treatments.root_canal"],
    [5012, "extra_treatments.root_canal"],
    [5013, "extra_treatments.root_canal"],
    [5021, "Inlay"],
    [5031, "plan_calculator.state_6"],
    [5041, "extra_treatments.hygiene_treatment"], // translate - Higiénia kezelés
    [7001, "E-max"],
    [7002, "Empress"],
    [7003, "extra_treatments.zirconium"], // translate - Cirkónium
]);

/** @type {Map<string, string>} */
export const keyMap = new Map([
    ["all_on_4", "all-on-4"],
    ["all_on_6", "all-on-6"],
    ["fast_and_fixed_4", "bredent-fast-and-fixed-4"],
    ["fast_and_fixed_6", "bredent-fast-and-fixed-6"],
    ["full_bridge", "full-bridge"],
    ["full_dentures", "full-dentures"],
    ["bridge", "full-jaw-6"],
    ["dentures_with_bar", "dentures-with-bar"],
    ["full_jaw_6_12", "full-jaw-6-12"],
    ["full_jaw_6_14", "full-jaw-6-14"],
    ["full_jaw_8_12", "full-jaw-8-12"],
    ["full_jaw_8_14", "full-jaw-8-14"],
    ["mini_4", "mini-4"],
    ["mini_6", "mini-6"],
    ["one_phase_8", "one-phase-8"],
    ["preci_vertix", "preci-vertix"],
]);

// http://data.fixer.io/api/latest?access_key=28f4959a04fb5bd3fb568679407b077e&format=1
export const convertCurrency = require("../../configs/exchange-rates.json");

export const i18nRE = /{([a-z_.]+)}/;

export const {dentalStates} = require("../../configs/settings/countries/us.json");

/**
 *
 * @param {number} amount
 * @return {number}
 */
export const rounder = (amount) => {
    const {round} = Math;
    const len = parseInt(amount.toString()).toString().length;
    const delta = 10 ** (len - 2);

    return round(amount / delta) * delta;
};

/**
 *
 * @param {string} from
 * @param {string} to
 * @param {number} amount
 * @param {string} base
 * @return {number}
 */
export const calcPrice = (from, to, amount, base = "EUR") => {
    const {rates} = convertCurrency;
    const main = Number(rates[base]);
    const price = main / Number(rates[from]) * Number(rates[to]) * amount;

    return rounder(price);
};

/**
 *
 * @param {string} key
 * @param {string} language
 * @return {string[]}
 */
export const getPhrases = (key, language) => {
    const phrases = protocolKeyMap.get(key);

    if (!phrases) {
        return [""];
    }

    return phrases.map((phrase) => {
        if (!phrase || !phrase.includes(".")) {
            return phrase;
        }

        if (!phrase.includes("{")) {
            return app.$t(phrase, language);
        }

        const match = phrase.match(i18nRE);

        if (!match) {
            return phrase;
        }

        return phrase.replace(i18nRE, app.$t(match[1], language));
    });
};

/**
 *
 * @param {string[]} variation
 * @param {string} key
 * @param {string} language
 * @return {string[]|string}
 */
export const getProtocolTitleTranslation = (variation, key, language) => {
    let result = variation["en"];

    // TODO: change try-catch
    try {
        result = getPhrases(key, language);
    } catch (error) {
        captureException(error);
    }

    return result;
};

/**
 *
 * @param {string} language
 * @return {void}
 */
export const translateProtocolTitles = (language) => {
    if (!("protocols" in app.$store.state.localSettings)) {
        return;
    }

    Object.keys(app.$store.state.localSettings.protocols).forEach((key) => {
        const protocol = app.$store.state.localSettings.protocols[key];

        if (typeof protocol.variation_titles === "undefined") {
            return;
        }

        const translateTitle = (title, index) => {
            if (typeof app.$store.state.localSettings.protocols[key].variation_titles[index][language] !== "undefined") {
                if (app.$store.state.localSettings.protocols[key].variation_titles[index][language].length > 0) {
                    return;
                }
            }

            app.$set(app.$store.state.localSettings.protocols[key].variation_titles[index], language, title);
        };

        protocol.variation_titles.forEach((variation) => {
            getProtocolTitleTranslation(variation, key, language).forEach(translateTitle);
        });
    });
};

/**
 *
 * @param {string} currency
 * @return {void}
 */
export const exchangeProtocolPrices = (currency) => {
    if (!("protocols" in app.$store.state.localSettings)) {
        return;
    }

    Object.keys(app.$store.state.localSettings.protocols).forEach((key) => {
        const protocol = app.$store.state.localSettings.protocols[key];

        if (typeof protocol.variation_prices === "undefined") {
            return;
        }

        const file = keyMap.get(key);

        if (!file) {
            return log(`file not found: ../../configs/protocols/countries/us/${file}.json`);
        }

        const {variation_prices: prices} = require(`../../configs/protocols/countries/us/${file}.json`);

        protocol.variation_prices.forEach((variation, index) => {
            let price = prices[index] || {"USD": 0};

            price = calcPrice("USD", currency, Number(price["USD"]));

            if (protocol.variation_prices[index][currency] > 0) {
                return;
            }

            protocol.variation_prices[index][currency] = price;
        });
    });
};

/**
 *
 * @param {string} language
 * @return {void}
 */
export const translateTreatmentTitles = (language) => {
    if (!("dentalStates" in app.$store.state.localSettings)) {
        return;
    }

    Object.entries(app.$store.state.localSettings.dentalStates).forEach(([id, item]) => {
        const languageKey = languageKeyMap.get(Number(id));

        if (!languageKey) {
            return;
        }

        let title = languageKey.includes(".") ? app.$t(languageKey, language) : languageKey;

        // For root canal treatments.
        if ([5011, 5012, 5013].includes(Number(id))) {
            let number = id.toString();

            number = number[number.length - 1];

            // Ex: root canal (2)
            if (language !== "ru") {
                title = `${title} (${number})`;
            } else {
                title = `${title} ${number}`;
            }
        }

        if (app.$store.state.localSettings.dentalStates[id].title[language]) {
            return;
        }

        app.$set(app.$store.state.localSettings.dentalStates[id].title, language, title);
    });
};

/**
 *
 * @param {string} currency
 * @return {void}
 */
export const exchangeTreatmentPrices = (currency) => {
    if (!("dentalStates" in app.$store.state.localSettings)) {
        return;
    }

    Object.entries(app.$store.state.localSettings.dentalStates).forEach(([id, item]) => {
        // TODO: change try-catch
        try {
            if (item.hidden) {
                return;
            }

            if (item.price && item.price[currency]) {
                return;
            }

            let price = {"USD": 0};

            if (dentalStates.hasOwnProperty(id) && dentalStates[id].hasOwnProperty('price')) {
                price = dentalStates[id].price;
            }

            price = Number(price["USD"]);
            price = calcPrice("USD", currency, price);

            app.$set(app.$store.state.localSettings.dentalStates[id].price, currency, price);
        } catch (error) {
            captureException(error);
        }
    });
};
